// FadeTransition.jsx
import React, { useState, useEffect } from "react";

const FadeTransition = ({ show, children }) => {
  // Local state to control when children are rendered.
  const [display, setDisplay] = useState(show);

  // When 'show' becomes true, ensure children are rendered.
  useEffect(() => {
    if (show) {
      setDisplay(true);
    }
  }, [show]);

  // When the transition ends and show is false, unmount children.
  const handleTransitionEnd = () => {
    if (!show) {
      setDisplay(false);
    }
  };

  return display ? (
    <div
      className={`transition-opacity duration-500 absolute inset-0 ${
        show ? "opacity-100" : "opacity-0"
      }`}
      onTransitionEnd={handleTransitionEnd}
    >
      {children}
    </div>
  ) : null;
};

export default FadeTransition;
